/**
 * @author vishwadeep.kapoor
 * @see /client/containers/HandlePayment/index.js
* ThankYou
*/

import React, { PureComponent, Fragment } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import FontAwesomIcon from 'react-fontawesome';

import { AppWrappperHOC } from '../Root/HOC';
import Button from '../../components/Button';
import Container from '../../components/Container';
import WhiteBackground from '../../components/WhiteBackground';
import { selectDealBooking } from '../RestaurantDetails/selectors';
import { selectUserDetails, selectLoggedIn } from '../HeaderContainer/selectors';
import StyledThankYou from './StyledThankYou';
import { constants, eventTracking } from '../../devUtils';
import { TEXT_SUCCESS_ORDER, TEXT_FAIL_ORDER } from './constants';
import { successBookResturantDeal } from '../RestaurantDetails/actions';
// import { selectThankYouPage } from './selectors';

/**
 * @param {*boolean} isRestroBooking
 * @default false
 */
export const CUSTOMER_SUPPORT = (isRestroBooking = false) => {
  const mobile_number = isRestroBooking ? constants.PHONE_RESTAURANT_CUSTOMER_SUPPORT : constants.PHONE_CUSTOMER_SUPPORT;
  return (
    <Container>
      <div className="CustomerSupport">
        <h4>Customer Support</h4>
        <div className="DisplayFlex">
          <p className="CustomerSupportDetails"><FontAwesomIcon name="phone" />&nbsp;Call at <span className="CustomerBold"><a href={`tel:${mobile_number}`}>{mobile_number} </a></span></p>
          <p className="CustomerSupportDetails"><FontAwesomIcon name="envelope" />&nbsp; Email at <span className="CustomerBold"><a href="mailto:team@zaggle.in">team@zaggle.in</a></span></p>
        </div>
      </div>
    </Container>
  );
};

class ThankYou extends PureComponent { // eslint-disable-line react/prefer-stateless-function
  constructor(props) {
    super(props);
    const { getDealBookingDetails: { data }, getSelectUserDetails: { email, phone } } = this.props;
    const { transactionid, phone_number, numberofpeople, restaurant_name, location } = data || { transactionid: '' };
    this.state = { transactionid, email, phone, phone_number, restaurant_name, location, numberofpeople, preRoute: null, isSuccess: null };
  }

  /**
   * @event lifeCycle
   */
  componentWillMount() {
    const { history: { location: { state = null } = {} } } = this.props;
    if (state && state.preRoute === constants.LINK_MY_ORDERS) {
      const { queryString: { transaction_id: transactionid, order_no }, isSuccess } = state;
      this.setState({ transactionid, order_no, preRoute: state.preRoute, isSuccess });
    }
  }

  componentWillUnmount() {
    this.props.onSuccessBookResturantDeal({});
  }


  // For Restaurant booking
  renderBookingPage(transactionid, order_no, email, phone, phone_number, numberofpeople, restaurant_name, location) {
    const { isLoggedIn } = this.props;
    return (
      isLoggedIn ?
        <WhiteBackground className="alignCentre" style={{ marginTop: '115px' }}>
          {/* Below part has been commented as per EDGE-672 by nikhil (dev) and M. Nandini Reddy (products) */}
          {/* <h2 className="ThankHeader">Thank you!</h2>
          {phone ? <p>Your booking was completed successfully</p> : <p>Your booking request is taken!</p>}
          <h3>Booking ID: {order_no || transactionid}</h3>
          <br />
          {email ?
            <Fragment><p>Booking confirmation has been sent to {email} </p>
              <p>and to the phone number {phone}</p>
            </Fragment> :
            <Fragment><p>for {restaurant_name}, {location} for {numberofpeople} members</p>
              <p>and details has been sent to {phone_number}</p>
            </Fragment>} */}
          <h1>Error!</h1>
          <div>Please purchase a gift card to see the booking id</div>
          <br />
          <Link to={constants.LINK_MY_BOOKINGS} onClick={() => eventTracking.triggerEvent('Restaurant Deals', 'Thank you - My bookings')}>
            <Button className="MyOrderButton">My Bookings</Button>
          </Link>
        </WhiteBackground> :
        <WhiteBackground className="alignCentre" style={{ marginTop: '115px' }}>
          <h1>OOPS!</h1>
          <div>Please login to see the booking details</div>
        </WhiteBackground>
    );
  }

  /**
   * @param {*} transactionid or @param {*} order_no
   * @param {*user_email} email
   * @param {*user_phone} phone
   * @param {*boolean} isSuccess
   */
  renderOrderPage(transactionid, order_no, email, phone, isSuccess) {
    return (
      <WhiteBackground className="alignCentre" style={{ marginTop: '215px' }}>
        {isSuccess ? <h2 className="ThankHeader">Thank you!</h2> : ''}
        <p>{isSuccess ? TEXT_SUCCESS_ORDER : TEXT_FAIL_ORDER}</p>
        <h3>{order_no ? 'Order' : 'Transaction'} ID:{order_no || transactionid}</h3>
        <br />
        {isSuccess && <p>Order details has been sent to {email} </p>}
        {isSuccess && <p>and to the phone number {phone}</p>}
        <br />
        <Link to={constants.LINK_MY_ORDERS}>
          <Button className="MyOrderButton">My orders</Button>
        </Link>
      </WhiteBackground>
    );
  }

  render() {
    const { transactionid, order_no, email, phone, preRoute, isSuccess, phone_number, numberofpeople, restaurant_name, location } = this.state;
    const isRestroBooking = (preRoute !== constants.LINK_MY_ORDERS);
    return (
      <StyledThankYou>
        <Container>
          {preRoute === constants.LINK_MY_ORDERS ?
            this.renderOrderPage(transactionid, order_no, email, phone, isSuccess)
            : this.renderBookingPage(transactionid, order_no, email, phone, phone_number, numberofpeople, restaurant_name, location)}
        </Container>
        {CUSTOMER_SUPPORT(isRestroBooking)}
      </StyledThankYou>
    );
  }
}

ThankYou.propTypes = {
  onSuccessBookResturantDeal: PropTypes.func, // eslint-disable-line react/no-unused-prop-types
  getDealBookingDetails: PropTypes.shape({
    data: PropTypes.shape({
      transactionid: PropTypes.string,
    }),
  }),
  getSelectUserDetails: PropTypes.shape({
    email: PropTypes.string,
    phone: PropTypes.string,
  }),
  history: PropTypes.object.isRequired,
  isLoggedIn: PropTypes.bool,
};

ThankYou.defaultProps = {
};

const mapDispatchToProps = (dispatch) => ({
  onSuccessBookResturantDeal: (payload) => dispatch(successBookResturantDeal(payload)),
});

const mapStateToProps = createStructuredSelector({
  getDealBookingDetails: selectDealBooking(),
  getSelectUserDetails: selectUserDetails(),
  isLoggedIn: selectLoggedIn(),
  // ThankYou: selectThankYouPage(),
});

const component = connect(mapStateToProps, mapDispatchToProps)(AppWrappperHOC(ThankYou));
export default component;



// WEBPACK FOOTER //
// client/containers/ThankYou/index.js